import {
  ANDROID_PLAY_STORE_BADGE_SRC,
  ANDROID_PLAY_STORE_URL,
  IOS_APP_STORE_BADGE_SRC,
  IOS_APP_STORE_URL,
} from "@/lib/constants/mobile-apps";
import Image from "next/image";
import Link from "next/link";

const storeLinkClassName =
  "inline-flex min-h-11 items-center rounded-md transition-opacity duration-200 hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40 focus-visible:ring-offset-2";

const badgeClassName = "h-11 w-auto object-contain";

/**
 * Official iOS and Android store badges that open the Digital Aggregate
 * listings. Used on the sign-in page.
 */
export function MobileAppDownloadLinks() {
  return (
    <nav
      aria-label="Download the Digital Aggregate mobile app"
      className="mt-6 border-t border-gray-200 pt-5"
    >
      <p className="mb-3 text-center text-[12px] text-text-tertiary">
        Get the mobile app
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Link
          href={IOS_APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Download Digital Aggregate from the Apple App Store"
          className={storeLinkClassName}
        >
          <Image
            src={IOS_APP_STORE_BADGE_SRC}
            alt="Download on the App Store"
            width={269}
            height={90}
            className={badgeClassName}
          />
        </Link>
        <Link
          href={ANDROID_PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Get Digital Aggregate on Google Play"
          className={storeLinkClassName}
        >
          <Image
            src={ANDROID_PLAY_STORE_BADGE_SRC}
            alt="Get it on Google Play"
            width={282}
            height={83}
            className={badgeClassName}
          />
        </Link>
      </div>
    </nav>
  );
}
